import { render, staticRenderFns } from "./generatedds.vue?vue&type=template&id=42616530"
import script from "./generatedds.vue?vue&type=script&lang=js"
export * from "./generatedds.vue?vue&type=script&lang=js"
import style0 from "./generatedds.vue?vue&type=style&index=0&id=42616530&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports